import axios from "axios";

/**
 * Customer Retention (CRM) Dashboard — the Customer Retention Manager's weekly
 * scorecard (OM Part 16). Gated server-side on dashboard.customer_retention.
 */
export default {
  namespaced: true,
  state: {
    dashboard: null,
    loading: false,
  },
  getters: {
    dashboard(state) {
      return state.dashboard;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_DASHBOARD(state, dashboard) {
      state.dashboard = dashboard;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetch_dashboard({ commit }) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/customer_retention/dashboard");
        commit("SET_DASHBOARD", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
